<template>
  <div>
    <el-dialog title="选择奖品" :visible.sync="dialogVisibleFrom" width="950px" center @close="dialogClose">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-if="isShowFirst" label="优惠券" name="first">
          <el-tabs v-model="listName" type="card" @tab-click="handleClickTwo">
            <el-tab-pane label="店铺内部券" name="first">
              <div class="topTis">
                <i class="el-icon-warning" style="color: #fe8f8a; marginright: 8px; font-size: 14px"></i>
                <div class="desc">
                  <p>
                    优惠券类型推荐选择【免费领取】【不公开】【全平台】的优惠券。
                    <el-button style="margin: 0 60px" type="text" @click="jumpCreation">去创建优惠券></el-button>
                    <!-- <el-button type="text" @click="jumpCreation"
                      >优惠券创建教程></el-button
                    > -->
                  </p>
                </div>
              </div>
              <input-form :inputData="inputData" @toParentVal="searchForm" :btnPosition="true" style="margin: 20px 0"></input-form>
              <el-table
                v-loading="tableLoading"
                :data="internalTable"
                style="width: 100%"
                :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
                :cell-style="{ 'text-align': 'left' }"
              >
                <el-table-column prop="name" label="名称" width="160"> </el-table-column>
                <el-table-column prop="discount" label="面额" width="120"> </el-table-column>
                <el-table-column prop="quota" label="使用条件" width="120"> </el-table-column>
                <el-table-column label="领取时间" width="240">
                  <template slot-scope="scope">
                    <span>起:{{ scope.row.takeBeginTime }}</span
                    ><br />
                    <span>止:{{ scope.row.takeEndTime }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="有效期" width="240">
                  <template slot-scope="scope">
                    <span>起:{{ scope.row.beginTime }}</span
                    ><br />
                    <span>止:{{ scope.row.endTime }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="类型" width="120">
                  <template slot-scope="scope">
                    <span v-if="scope.row.grantType == 1">促销绑定</span>
                    <span v-if="scope.row.grantType == 2">推送</span>
                    <span v-if="scope.row.grantType == 3">免费领取</span>
                    <span v-if="scope.row.grantType == 4">京豆换券</span>
                    <!-- <span v-if="scope.row.grantType == 5">互动平台</span> -->
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      style="width: 50px"
                      type="text"
                      class="Notetake"
                      @click="
                        chooseTab(scope.row);
                        dialogVisibleFrom = false;
                      "
                    >
                      选择
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 表格分页 -->
              <el-pagination
                style="text-align: right; margin-top: 20px"
                @size-change="handleSizeChange"
                background
                @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 30, 50, 100, 500]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                :current-page="1"
              ></el-pagination>
            </el-tab-pane>
            <el-tab-pane label="店铺外部券" name="second">
              <div class="topTis">
                <i class="el-icon-warning" style="color: #fe8f8a; marginright: 8px; font-size: 14px"></i>
                <div class="desc">
                  <p>
                    外部优惠券需要手动添加。
                    <el-button type="text" @click="jumpSansCreation">添加外部优惠券></el-button>
                  </p>
                </div>
              </div>
              <input-form :inputData="inputDataTwo" @toParentVal="searchFormTwo" :btnPosition="true" style="margin: 20px 0"></input-form>
              <el-table
                v-loading="tableLoading"
                :data="externalTable"
                style="width: 100%"
                :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
                :cell-style="{ 'text-align': 'left' }"
              >
                <el-table-column prop="name" label="名称"> </el-table-column>
                <el-table-column prop="discount" label="面额" width="100"> </el-table-column>
                <el-table-column prop="quota" label="使用条件" width="100"> </el-table-column>
                <el-table-column label="领取时间" width="240">
                  <template slot-scope="scope">
                    <span>起:{{ scope.row.takeBeginTime }}</span
                    ><br />
                    <span>止:{{ scope.row.takeEndTime }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="有效期" width="240">
                  <template slot-scope="scope">
                    <span>起:{{ scope.row.beginTime }}</span
                    ><br />
                    <span>止:{{ scope.row.endTime }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <!-- <span class="Notetake" @click="
                        chooseTab(scope.row);
                        dialogVisibleFrom = false;">选择</span> -->
                    <el-button
                      class="Notetake"
                      type="text"
                      @click="
                        chooseTab(scope.row);
                        dialogVisibleFrom = false;
                      "
                    >
                      选择
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                style="text-align: right; margin-top: 20px"
                @size-change="handleSizeChangeTwo"
                background
                @current-change="handleCurrentChangeTwo"
                :page-sizes="[10, 20, 30, 50, 100, 500]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNumTwo"
                :current-page="1"
              ></el-pagination>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
        <el-tab-pane label="京豆" name="second">
          <div class="topTis" style="background: #fff;">
            <!-- <i
              class="el-icon-warning"
              style="color: #fe8f8a; marginright: 8px; font-size: 14px"
            ></i>
            <div class="desc">
              <p>注意：为保证活动奖品正常发送，建议选择发豆规则与奖品发放规则一致的计划（比如活动期间最多邀请5人，则发豆规则建议选择“每日活动内发豆次数大于等于5次的京豆计划”）</p>
            </div> -->
          </div>

          <el-form ref="jingduoForm:" :model="jingduoForm" label-width="200px">
            <el-form-item label="选择京豆计划:">
              <el-select v-model="jingduoForm.region" placeholder="请选择" @change="planChange" style="width: 215px">
                <el-option v-for="(item, index) in selectList" :key="index" :label="item.label" :value="item"></el-option>
              </el-select>
              <el-button type="text" @click="getJingdouList">刷新</el-button>
              <el-button style="width:auto" type="primary" @click="jumpJingduo">创建京豆计划</el-button>
              <div v-show="activeSendtimes">
                <span>京豆计划的发豆次数，最多</span>
                <span style="color:#FE4D45"> {{ activeSendtimes }} </span>次
              </div>
            </el-form-item>
            <el-form-item label="单份奖励个数:">
              <el-input v-model="jingduoForm.count" @input.native="checkputn" style="width: 215px"></el-input>
              <span> 个京豆 （每人每次发送的京豆个数）</span>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                style="width: 180px"
                @click="
                  getJingdouData();
                  setJingdouData();
                "
                >选择京豆发放</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane :disabled="actual" label="实物" name="third">
          <div class="topTis">
            <i class="el-icon-warning" style="color: #fe8f8a; marginright: 8px; font-size: 14px"></i>
            <div class="desc">
              <p>实物奖品需要用户中奖后在线填写邮寄地址方</p>
            </div>
          </div>
          <el-form ref="objectForm" :model="objectForm" label-width="200px">
            <el-form-item label="奖品来源:">
              <el-radio-group v-model="objectForm.resource" @change="cleanImg">
                <el-radio label="2">直接填写</el-radio>
                <el-radio label="1">从店铺中选择</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="objectForm.resource == 2">
              <el-upload
                ref="upload"
                action="#"
                list-type="picture-card"
                :on-change="handleChange"
                :on-remove="handleRemove"
                :http-request="httpRequest"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <!-- <el-dialog :visible.sync="dialogVisible" style="z-index:3050">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog> -->
              <span style="color: #fe4d45; font-size: 12px">建议尺寸：200*200像素，图片大小不能超过300K，类型：JPG、PNG</span>
            </el-form-item>
            <el-form-item v-if="objectForm.resource == 1">
              <div v-if="objectForm.logo && objectForm.resource == 1">
                <img :src="objectForm.logo" alt="" style="width: 150px; height: 150px" />
              </div>
              <el-button @click="dialogFormVisible = true">选择店铺商品</el-button>
            </el-form-item>
            <el-form-item label="奖品名称:">
              <el-input v-model="objectForm.name" maxlength="12" show-word-limit style="width: 220px"></el-input>
            </el-form-item>
            <el-form-item label="奖品价值:">
              <el-input v-model="objectForm.discount" @input.native="checkputn" style="width: 220px"></el-input>
              <span> 元/件</span>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="width: 180px" @click="changeJP()">选择实物奖品</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="店铺积分" name="four">
          <div class="topTis">
            <i class="el-icon-warning" style="color: #fe8f8a; marginright: 8px; font-size: 14px"></i>
            <div class="desc">
              <p>店铺积分：发放积分需要加入京东会员体系，并开通积分功能</p>
            </div>
          </div>
          <el-form ref="integralForm" :model="integralForm" label-width="200px">
            <el-form-item label="单份积分数量:">
              <el-input v-model.number="integralForm.discount" @input.native="checkputn" style="width: 220px"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                style="width: 180px"
                @click="
                  storePoint();
                  dialogVisibleFrom = false;
                "
                >选择店铺积分奖品</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="京东E卡" name="fird">
          <div class="topTis">
            <i class="el-icon-warning" style="color: #fe8f8a; marginright: 8px; font-size: 14px"></i>
            <div class="desc">
              <p>
                根据京东规则，新创建计划开始时间需要在当前时间5分钟后，如果您是刚刚创建计划，请稍后点击刷新
              </p>
            </div>
          </div>
          <el-form ref="ekForm" :model="ekForm" label-width="200px">
            <el-form-item label="选择京东E卡计划:">
              <el-select v-model="ekForm.region" placeholder="请选择" @change="change">
                <el-option v-for="(item, index) in eKselectList" :key="index" :label="item.label" :value="item"></el-option>
              </el-select>
              <el-button type="text" @click="acquireAssets">刷新</el-button>
              <el-button type="primary" style="width: 180px" @click="jumpEkCz">创建京东E卡官方充值</el-button>
              <el-button type="primary" style="width: 180px" @click="jumpEk">创建京东E卡发放计划</el-button>
              <p>
                剩余
                <span style="color: #fe4d45">{{ ekForm.quantityBalance }}</span>
                张
              </p>
            </el-form-item>
            <el-form-item label="单份奖品:">
              <el-input v-model="ekForm.num" style="width: 220px" :disabled="true"></el-input>
              <span> 张（京东E卡单份奖品每人每次只能奖励1张）</span>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                style="width: 180px"
                @click="
                  jingDonData();
                  jingDonEka();
                  dialogVisibleFrom = false;
                "
                >选择京东E卡奖品</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="爱奇艺会员" name="six">
          <div class="topTis">
            <i class="el-icon-warning" style="color: #fe8f8a; marginright: 8px; font-size: 14px"></i>
            <div class="desc">
              <p>
                根据京东规则，新创建计划开始时间需要在当前时间5分钟后，如果您是刚刚创建计划，请稍后点击刷新
              </p>
            </div>
          </div>
          <el-form ref="aqyForm" :model="aqyForm" label-width="200px">
            <el-form-item label="选择爱奇艺会员计划:">
              <el-select v-model="aqyForm.region" placeholder="请选择" @change="change">
                <el-option v-for="(item, index) in eKselectList" :key="index" :label="item.label" :value="item"></el-option>
              </el-select>
              <el-button type="text" @click="acquireAssets">刷新</el-button>
              <el-button type="primary" style="width: 180px" @click="jumpaqyCz">创建爱奇艺官方充值</el-button>
              <el-button type="primary" style="width: 180px" @click="jumpaqy">创建爱奇艺发放计划</el-button>
              <p>
                剩余
                <span style="color: #fe4d45">{{ aqyForm.quantityBalance }}</span>
                张
              </p>
            </el-form-item>
            <el-form-item label="单份奖品:">
              <el-input v-model="aqyForm.num" style="width: 220px" :disabled="true"></el-input>
              <span> 张（爱奇艺会员单份奖品每人每次只能奖励1张）</span>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                style="width: 180px"
                @click="
                  jingDonData();
                  aqyList();
                  dialogVisibleFrom = false;
                "
                >选择爱奇艺会员奖品</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="京东PLUS会员" name="sev">
          <div class="topTis">
            <i class="el-icon-warning" style="color: #fe8f8a; marginright: 8px; font-size: 14px"></i>
            <div class="desc">
              <p>
                根据京东规则，新创建计划开始时间需要在当前时间5分钟后，如果您是刚刚创建计划，请稍后点击刷新
              </p>
            </div>
          </div>
          <el-form ref="plusForm" :model="plusForm" label-width="200px">
            <el-form-item label="选择京东PLUS会员计划:">
              <el-select v-model="plusForm.region" placeholder="请选择" @change="change">
                <el-option v-for="(item, index) in eKselectList" :key="index" :label="item.label" :value="item"></el-option>
              </el-select>
              <el-button type="text" @click="acquireAssets">刷新</el-button>
              <el-button type="primary" style="width: 180px" @click="jumpPlusCz">创建PLUS会员充值</el-button>
              <el-button type="primary" style="width: 180px" @click="jumpPlus">创建PLUS会员发放</el-button>
              <p>
                剩余
                <span style="color: #fe4d45">{{ plusForm.quantityBalance }}</span>
                张
              </p>
            </el-form-item>
            <el-form-item label="单份奖品:">
              <el-input v-model="plusForm.num" style="width: 220px" :disabled="true"></el-input>
              <span> 京东PLUS会员单份奖品每人每次只能奖励1张</span>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                style="width: 180px"
                @click="
                  jingDonData();
                  plusList();
                  dialogVisibleFrom = false;
                "
                >选择京东PLUS奖品</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="现金红包" name="eig">
          <div class="topTis">
            <i class="el-icon-warning" style="color: #fe8f8a; marginright: 8px; font-size: 14px"></i>
            <div class="desc">
              <p>
                根据京东规则，红包计划创建后10分钟才能生效，为避免等待时间，请提前创建活动！
              </p>
              <p>默认红包计划最短不少于3天，最长不超过30天，详见红包权益；</p>
            </div>
          </div>
          <el-form ref="ekForm" :model="redForm" label-width="200px">
            <el-form-item label="选择现金红包计划:">
              <!-- <el-select v-model="redForm.region" placeholder="请选择">
                <el-option label="计划一" value="shanghai"></el-option>
                <el-option label="计划二" value="beijing"></el-option>
                <el-option label="计划三" value="beijing"></el-option>
              </el-select> -->
              <el-select v-model="redForm.region" placeholder="请选择" @change="change">
                <el-option v-for="(item, index) in redSelectList" :key="index" :label="item.label" :value="item"></el-option>
              </el-select>
              <el-button type="text" @click="redBag">刷新</el-button>
              <el-button type="primary" style="width: 180px" @click="jumpRedCz">创建现金红包充值</el-button>
              <el-button type="primary" style="width: 180px" @click="jumpRed">创建现金红包发放</el-button>
              <p>
                剩余
                <span style="color: #fe4d45">{{ redForm.quantityBalance }}</span>
                张
              </p>
            </el-form-item>
            <el-form-item label="单份奖品:">
              <el-input v-model="redForm.num" style="width: 220px" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                style="width: 180px"
                @click="
                  redData();
                  redList();
                  dialogVisibleFrom = false;
                "
                >选择红包奖品</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <!-- 选择商品弹窗 -->
    <el-dialog title="选择商品" :visible.sync="dialogFormVisible" width="820px">
      <input-form style="margin: 20px 0" :inputData="commodityList" @toParentVal="searchContent"></input-form>
      <el-table
        :data="tableShopData"
        stripe
        style="width: 90%; margin: 0 auto"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <el-table-column width="100">
          <template slot-scope="scope">
            <img :src="scope.row.logo" class="avar" alt="商品图片" style="height: 60px; width: 60px" />
          </template>
        </el-table-column>
        <el-table-column prop="skuName" label="商品名称" width="300">
          <template slot-scope="scope">
            <a :href="scope.row.itemUrl" target="_blank"
              >{{ scope.row.skuName }}<br />
              ¥{{ scope.row.jdPrice }}</a
            >
            <!-- <span>{{ scope.row.skuName }}</span
            ><br />
            <span>¥{{ scope.row.jdPrice }}</span> -->
          </template>
        </el-table-column>
        <el-table-column prop="skuId" label="SKU ID" width="200"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="chooseShop(scope.row)" style="width: 50px">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin: 40px 80px 0 0; text-align: right"
        background
        @size-change="handleSizeChangeThr"
        @current-change="handleCurrentChangeThr"
        :current-page="1"
        :page-sizes="[5, 10, 30, 50, 100]"
        :page-size="5"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
        :total="totalListThr"
      ></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import inputForm from "../../components/inputForm";
import SelectGoods from "../../components/selectGoodsMonitor";
import { couponList, jingdouList, allAccountList, redPacketList } from "@/api/integralCenter/prizeCenter.js";
import { querySellerCouponWriteList, querySellerCouponExternalList } from "@/api/integralCenter/couponWriteController";
import { getTaobaoItemListSku, getSellercats } from "@/api/analysis/ware-controller.js";
import { uploadpic } from "@/api/paradiseAndTaskCommonController.js";
const actionType = ["", "jingdouPut"];
export default {
  name: "selectProduct",
  components: {
    inputForm,
    SelectGoods,
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    putPrize: {
      type: Object,
    },
  },
  data() {
    return {
      isShowFirst: true, //邀请开卡活动隐藏优惠券一栏
      actual: false,
      fileList: [],
      form: {
        imageUrl: "",
      },
      dialogFormVisible: false,
      // returnSelectGoods: [],
      returnSelectGoodsAppoint: [], //选择商品回显
      postForm: {
        orderStartTime: "",
        testSelect: 0,
      },
      goodsStateLength: 0,
      goodsStateLength1: 0,
      selectList: [],
      eKselectList: [],
      redSelectList: [],
      tableLoading: true,
      activeName: "first",
      listName: "first",
      inputData: [
        {
          name: "优惠券类型:",
          val: "type",
          placeholder: "请选择",
          selectArr: [
            { label: "京券", id: 0 },
            { label: "东券", id: 1 },
          ],
        },
        {
          name: "优惠券名称:",
          val: "name",
          placeholder: "请输入",
        },
        {
          name: "优惠券面额:",
          val: "discount",
          placeholder: "请输入",
        },
      ],
      inputDataTwo: [
        {
          name: "优惠券名称:",
          val: "name",
          placeholder: "请输入",
        },
        {
          name: "优惠券面额:",
          val: "discount",
          placeholder: "请输入",
        },
      ],
      internalTable: [],
      externalTable: [],
      totalNum: 0,
      totalNumTwo: 0,
      jingduoForm: {
        count: null,
      },
      objectForm: {
        logo: "",
        resource: "1",
        name: "",
        discount: null,
      },
      integralForm: {
        discount: null,
      },
      ekForm: {},
      aqyForm: {},
      plusForm: {},
      redForm: {},
      dialogImageUrl: "",
      dialogVisible: false,
      dialogVisibleFrom: this.isShow,
      formList: {
        current: 1,
        size: 10,
        isTake: 1,
      },
      formListTwo: {
        current: 1,
        size: 10,
        isTake: 1,
      },
      formLitJD: {
        current: 1,
        size: 100,
        isFilterUsed: true,
        status: 2,
      },
      formLitZC: {
        current: 1,
        size: 100,
        isFilterUsed: true,
        status: 2,
      },
      formLitRed: {
        current: 1,
        size: 100,
        isFilterUsed: true,
        status: 2,
      },
      jingdouData: {},
      tabActive: 3,
      selectZCList: {},
      zcData: {},
      commodityList: [
        {
          name: "商品类目:",
          placeholder: "请选择",
          val: "categoryId",
          cascaderArr: [],
          multiple: true,
          width: 240,
        },
        {
          name: "SKU ID:",
          val: "skuId",
          placeholder: "请输入SKU ID, 多个请用,隔开",
          width: 240,
        },
        {
          name: "商品名称:",
          val: "skuName",
          placeholder: "请输入商品名称",
          width: 240,
        },
        {
          name: "商品状态:",
          val: "skuStatus",
          default: 1,
          selectArr: [
            { label: "全部", id: null },
            { label: "上架", id: 1 },
            { label: "下架", id: 2 },
          ],
          width: 136,
        },
      ],
      tableShopData: [],
      totalListThr: 0,
      formShopList: { current: 1, size: 5, skuStatus: 1 },
      nowTime: "",
      activeSendtimes: "",
      planList: {
        jingdou: {},
      },
    };
  },
  mounted() {
    this.quireList();
    this.getShopList();
    this.getSeller();
    // 邀请开卡v3.4
    if (this.$parent.localStepNum == 4) {
      this.setDefalut();
      console.log(this.$parent.clickActual);
      var tj1 = this.$parent.tableData.some((i) => {
        return i.prizeType == 3;
      });
      // 点击到已选实物奖品的条件，不置灰实物tab
      var tj2 = this.$parent.clickActual;
      this.actual = tj1 && tj2 ? true : false;
      console.log(tj1, tj2);
      this.isShowFirst = false;
      this.activeName = "second";
    }
  },
  methods: {
    planChange(val) {
      console.log(val);
      this.activeSendtimes = val.sendTimes;
    },
    setDefalut() {
      if (this.putPrize.prizeType) {
        console.log(this.putPrize);
      }
    },
    dialogClose() {
      this.$emit("close");
    },

    cleanImg() {
      this.objectForm.logo = "";
      this.objectForm.name = "";
      this.objectForm.discount = null;
    },
    dateFormat() {
      let date = new Date();
      let year = date.getFullYear();

      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      this.nowTime = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
      // console.log(this.nowTime);
    },
    jumpCreation() {
      window.open("https://passport.shop.jd.com/login/index.action?ReturnUrl=https%3A%2F%2Fpromo.shop.jd.com%2Fweb%2Fcoupon%2Fdetail%2Fshop%2F0%3F");
      // let routeUrl = this.$router.resolve({
      //   path: "/integralCenter/prizeCenter/coupon_management",
      // });
      // window.open(routeUrl.href, "_blank");
    },
    jumpSansCreation() {
      this.$router.push({
        path: "./prizeCenter/coupon_management",
        query: { to: 1 },
      });
    },
    jumpJingduo() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
      });
      window.open(routeUrl.href, "_blank");
    },
    jumpEkCz() {
      window.open("http://quanyi.shop.jd.com/#/eAccount");
    },
    jumpEk() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
        query: { tabAct: 3 },
      });
      window.open(routeUrl.href, "_blank");
    },
    jumpaqyCz() {
      window.open("https://quanyi.shop.jd.com/#/aiqiyiAccount");
    },
    jumpaqy() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
        query: { tabAct: 4 },
      });
      window.open(routeUrl.href, "_blank");
    },
    jumpPlusCz() {
      window.open("https://quanyi.shop.jd.com/#/plusAccount");
    },
    jumpPlus() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
        query: { tabAct: 5 },
      });
      window.open(routeUrl.href, "_blank");
    },
    jumpRedCz() {
      window.open("https://quanyi.shop.jd.com/#/redGiftAccount");
    },
    jumpRed() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
        query: { tabAct: 6 },
      });
      window.open(routeUrl.href, "_blank");
    },
    //获取店铺商品
    getShopList() {
      // this.formShopList;
      getTaobaoItemListSku(this.formShopList).then((res) => {
        this.tableShopData = res.data.records;
        this.totalListThr = res.data.total;
        // console.log(res, 1111111111);
      });
    },

    getSeller() {
      // 获取商品类目
      getSellercats().then((res) => {
        let data = this.transverter(res.data);
        // console.log(data);
        this.getTrees(data);
        // console.log(data);
        // debugger
        let list = data.filter((item) => item.parent_id == 0);
        // console.log('list',list);
        let cascaderArr = list.map((item) => {
          return {
            label: item.label,
            value: item.value,
            children: item.children,
          };
        });
        console.dir(cascaderArr);

        this.commodityList[0].cascaderArr = cascaderArr;
      });
      // this.$nextTick(() => {
      //   this.$refs.inputForm.formSearch();
      // });
    },
    transverter(data) {
      // 排重
      let obj = {};
      for (let i = 0; i < data.length; i++) {
        obj[data[i]["categoryId"]] = data[i];
      }
      let arr = Object.values(obj);
      var newData = [];
      // console.log(arr);
      for (var i = 0; i < arr.length; i++) {
        newData[i] = {
          value: arr[i].categoryId,
          parent_id: arr[i].parentId,
          label: arr[i].name,
          isChecked: false,
        };
      }
      return newData;
    },
    getTrees(list, parent_id = 0) {
      let parentObj = {};
      list.forEach((o) => {
        parentObj[o.id] = o;
      });
      if (!parent_id) {
        return list
          .filter((o) => !parentObj[o.parent_id])
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      } else {
        return list
          .filter((o) => o.parent_id == parent_id)
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      }
    },
    //实物选择
    chooseShop(val) {
      console.log(val);
      this.objectForm.logo = val.logo;
      this.objectForm.name = val.skuName.substr(0, 12);
      this.objectForm.discount = val.jdPrice;
      this.objectForm.wareId = val.wareId;
      this.dialogFormVisible = false;
    },
    searchContent(val) {
      if (val.categoryId) {
        this.formShopList.categoryId = val.categoryId.join(",");
      } else {
        this.formShopList.categoryId = "";
      }
      this.formShopList.skuId = val.skuId;
      this.formShopList.skuStatus = val.skuStatus;
      this.formShopList.skuName = val.skuName;
      this.getShopList();
    },
    //获取优惠券
    quireList() {
      this.dateFormat();
      // this.formList.beginTime = this.nowTime;
      couponList(this.formList).then((res) => {
        this.tableLoading = false;
        this.internalTable = res.data.records;
        this.internalTable.forEach((item) => {
          item.couponType = 1;
        });
        this.totalNum = Number(res.data.total);
      });
    },
    //查询外部优惠券信息
    querySellerCouponExternal() {
      this.tableLoading = true;
      querySellerCouponExternalList(this.formListTwo)
        .then((res) => {
          this.externalTable = res.data.records;
          this.externalTable.forEach((item) => {
            item.couponType = 2;
            item.couponId = Number(item.id);
          });
          this.totalNumTwo = Number(res.data.total);
          this.tableLoading = false;
          console.log(this.externalTable, 22244);
        })
        .catch((res) => {});
    },
    //输入框限制负数
    checkputn(e) {
      let filtered = e.target.value.replace(/^0|[^\d]/g, "");
      e.target.value = Number(filtered);
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
    },
    change(a) {
      console.log(a);
      this.ekForm.quantityBalance = a.value.quantityBalance;
      this.aqyForm.quantityBalance = a.value.quantityBalance;
      this.plusForm.quantityBalance = a.value.quantityBalance;
      this.redForm.quantityBalance = a.value.quantityTotal ? a.value.quantityTotal - a.value.quantityActual : "";
      this.ekForm.num = 1;
      this.aqyForm.num = 1;
      this.plusForm.num = 1;
      this.redForm.num = a.value.quantityAmount ? a.value.quantityAmount / a.value.quantityTotal : "";
    },
    //选择奖品弹窗
    openDialog() {
      this.dialogVisibleFrom = true;
      this.getJingdouList();
    },
    //查询京豆
    getJingdouList() {
      jingdouList(this.formLitJD)
        .then((res) => {
          let selectArr = res.data.records.map((item) => {
            return {
              label: item.planName,
              value: item.id,
              sendTimes: item.sendTimes,
            };
          });
          this.selectList = selectArr;
          this.planList.jingdou = res.data.records;
        })
        .catch((res) => {});
    },
    //京豆
    getJingdouData() {
      this.jingdouData = {
        couponId: this.jingduoForm.region.value,
        discount: this.jingduoForm.quota,
        name: this.jingduoForm.region.label,
        singleAmount: Number(this.jingduoForm.count),
      };
    },
    setJingdouData() {
      let jingdouPlanList = this.planList.jingdou;
      let item = jingdouPlanList.find((i) => {
        return i.id == this.jingdouData.couponId;
      });
      console.log(item);
      if (item) {
        // 梯度奖励
        if (this.$parent.ruleForm.isCumulativePrize) {
          let line = this.$parent.tableData[this.$parent.tableIndex];
          console.log(line);
          if (!line.peopleCount || Number(line.peopleCount) > 20) {
            this.$message.warning("京豆奖励需先填写最多邀请人数规则，且数目不可大于20人");
            return;
          } else if (Number(line.peopleCount) > item.sendTimes) {
            this.$message.error("奖品发放规则与京豆计划的发豆规则不一致，会导致奖品发放失败，请重新选择京豆计划～");
            return;
          }
        } else {
          if (!this.$parent.ruleForm.peopleCount || Number(this.$parent.ruleForm.peopleCount) > 20) {
            this.$message.warning("京豆奖励需先填写最多邀请人数规则，且数目不可大于20人");
            return;
          } else if (Number(this.$parent.ruleForm.peopleCount) > item.sendTimes) {
            this.$message.error("奖品发放规则与京豆计划的发豆规则不一致，会导致奖品发放失败，请重新选择京豆计划～");
            return;
          }

          console.log(this.$parent.ruleForm.peopleCount, item.sendTimes);
        }
      }
      // return
      this.dialogVisibleFrom = false;
      // this.jingdouData.couponId()
      this.$emit("choose-shop", this.jingdouData, 2);
    },
    //查询京东E卡,爱奇艺会员,京豆PLUS会员
    acquireAssets() {
      allAccountList(this.formLitZC)
        .then((res) => {
          let selectArr = res.data.records.map((item) => {
            return {
              label: item.planName,
              value: item,
            };
          });
          this.eKselectList = selectArr;
          // console.log(res, "res");
        })
        .catch((res) => {});
    },
    //查询红包
    redBag() {
      redPacketList(this.formLitRed)
        .then((res) => {
          let selectArr = res.data.records.map((item) => {
            return {
              label: item.planName,
              value: item,
            };
          });
          this.redSelectList = selectArr;
          // console.log(res, "res");
        })
        .catch((res) => {});
    },
    handleClick(tab, event) {
      console.log(tab.index);
      if (tab.index == "0") {
        this.formLitZC.assetType = 1;
      }
      if (tab.index == "1") {
        this.formLitZC.assetType = 2;
        this.jingduoForm.count = ""; //京豆
      }
      if (tab.index == "2") {
        this.formLitZC.assetType = 3; //实物
        this.objectForm.resource = "1";
        this.objectForm.name = "";
        this.objectForm.discount = "";
      }
      if (tab.index == "3") {
        this.formLitZC.assetType = 4; //店铺积分
        this.integralForm.discount = "";
      }
      if (tab.index == "4") {
        this.formLitZC.assetType = 5; //E卡
        this.ekForm.quantityBalance = "";
        this.ekForm.num = "";
      } else if (tab.index == "5") {
        this.formLitZC.assetType = 6; //爱奇艺会员
        this.aqyForm.quantityBalance = "";
        this.aqyorm.num = "";
      } else if (tab.index == "6") {
        this.formLitZC.assetType = 7; //PLUS会员
        this.plusForm.quantityBalance = "";
        this.plusForm.num = "";
      }
      if (tab.index == "7") {
        this.formLitZC.assetType = 8; //现金红包
        this.redForm.num = "";
      }
      this.acquireAssets();
      this.redBag();
      // console.log(tab.index, this.tabActive);
    },
    handleClickTwo(tab, event) {
      // console.log(tab);
      // console.log(event);
      // console.log(tab.name);
      if (tab.name == "second") {
        this.querySellerCouponExternal();
      } else {
        // console.log(222);
      }
    },
    searchForm(val) {
      this.formList.type = val.type;
      this.formList.name = val.name;
      this.formList.discount = val.discount;
      this.quireList();
    },
    searchFormTwo(val) {
      this.formListTwo.name = val.name;
      this.formListTwo.discount = val.discount;
      this.querySellerCouponExternal();
    },
    chooseTab(val) {
      val.singleAmount = 1;
      this.$emit("choose-shop", val, 1);
    },
    storePoint() {
      this.integralForm.singleAmount = this.integralForm.discount;
      this.$emit("choose-shop", this.integralForm, 4);
    },
    jingDonData() {
      if ((this.formLitZC.assetType = 5)) {
        //E卡
        this.zcData = {
          couponId: this.ekForm.region.value.id,
          discount: this.ekForm.region.value.quota,
          name: this.ekForm.region.label,
          singleAmount: 1,
        };
      } else if ((this.formLitZC.assetType = 6)) {
        //爱奇艺会员
        this.zcData = {
          couponId: this.aqyForm.region.value.id,
          discount: this.aqyForm.region.value.quota,
          name: this.aqyForm.region.label,
          singleAmount: 1,
        };
      } else if ((this.formLitZC.assetType = 7)) {
        //PLUS会员
        this.zcData = {
          couponId: this.plusForm.region.value.id,
          discount: this.plusForm.region.value.quota,
          name: this.plusForm.region.label,
          singleAmount: 1,
        };
      }
      // console.log(this.zcData, 222);
    },
    // 现金红包设置
    redData() {
      console.log(this.redForm.region.value, 2222222);
      this.zcData = {
        couponId: this.redForm.region.value.id,
        discount: this.redForm.num,
        name: this.redForm.region.label,
        singleAmount: 1,
      };
    },
    changeJP() {
      this.zcData = {
        giftType: this.objectForm.resource,
        logo: this.objectForm.logo,
        couponId: this.objectForm.wareId,
        discount: this.objectForm.discount,
        name: this.objectForm.name,
        singleAmount: 1,
      };
      this.dialogVisibleFrom = false;
      this.$emit("choose-shop", this.zcData, 3);
    },
    jingDonEka() {
      this.$emit("choose-shop", this.zcData, 5);
    },
    aqyList() {
      this.$emit("choose-shop", this.zcData, 6);
    },
    plusList() {
      this.$emit("choose-shop", this.zcData, 7);
    },
    redList() {
      this.$emit("choose-shop", this.zcData, 8);
    },
    //上传图片
    handleChange(file, fileList) {
      const isLt3M = file.size < 1024 * 300;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 300K");
        this.$refs.upload.clearFiles();
      } else {
        this.fileList = fileList;
        this.$refs.upload.$children[1].$el.style.display = "none";
        // this.objectForm.name = file.name;
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          this.objectForm.logo = res.data;
        });
      }
    },

    handleRemove(file, fileList) {
      // this.fileList = [];
      // this.$refs.upload.clearFiles();
      // this.imageName = "";
      this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    httpRequest() {},
    //分页事件
    handleSizeChange(val) {
      this.formList.size = val;
      this.quireList();
    },
    handleCurrentChange(val) {
      this.formList.current = val;
      this.quireList();
    },
    handleSizeChangeTwo(val) {
      this.formListTwo.size = val;
      this.quireList();
    },
    handleCurrentChangeTwo(val) {
      this.formListTwo.current = val;
      this.quireList();
    },
    //分页事件
    handleSizeChangeThr(val) {
      this.formShopList.size = val;
      this.getShopList();
    },
    handleCurrentChangeThr(val) {
      this.formShopList.current = val;
      this.getShopList();
    },
  },
};
</script>

<style scoped lang="scss">
.Notetake {
  cursor: pointer;
  color: #7f85e9;
  &:hover {
    color: #fe4d45;
  }
}
.topTis {
  display: flex;
  align-items: baseline;
  color: #333;
  font-size: 14px;
  background: #fff9f9;
  margin: 30px;
  padding: 12px;
  color: #333;
  .desc {
    line-height: 20px;
  }
  p {
    margin-left: 5px;
    line-height: 20px;
  }
}
</style>
